import React from "react";
import Thankplant from "../img/Thankplant.png"

function Thanks()
{
    return (
        <div className="cactus-div">
            <img className="cactus" src={Thankplant} alt="thanks for visiting"/>
        </div>
    );
}

export default Thanks;